import { backEndAPIUrl } from 'constants/values';

export const getSeriesPipelineData = async ({ payload }) => {
  let urlSegment = payload.mini ? 'bodystyle-pipeline' : 'series-pipeline';
  const url = `${backEndAPIUrl}/dashboard/${urlSegment}/${payload.id}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    const seriesWithResponse = { responseBody, seriesId: payload };
    return seriesWithResponse;
  } else if (response.status === 422) {
    await response.json();
  }
};
